import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language, setLanguage, t } = useLanguage();

  return (
    <footer className="bg-white pt-10 pb-10 md:pt-12 md:pb-12" data-testid="footer">
      <div className="container-byron">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="block mb-6" data-testid="footer-logo">
              <img 
                src="/byron-logo-transparent-26.svg"
                alt="Byrōn"
                className="h-6 md:h-7 w-auto"
              />
            </Link>
            <p className="text-[#666] text-sm leading-relaxed mb-6 max-w-xs">
              {t('footer.tagline')}
            </p>
            <div className="text-sm text-[#666] space-y-1">
              <p>Chemin de Byron 12</p>
              <p>1223 Cologny, Geneva</p>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-2 md:col-start-7">
            <p className="text-xs uppercase tracking-[0.2em] text-[#999] mb-4">{t('footer.navigation')}</p>
            <ul className="space-y-3">
              <li>
                <Link to="/acheter" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  {language === 'fr' ? 'Acheter' : 'Buy'}
                </Link>
              </li>
              <li>
                <Link to="/louer" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  {language === 'fr' ? 'Louer' : 'Rent'}
                </Link>
              </li>
              <li>
                <Link to="/off-market" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  {t('nav.offMarket')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[#999] mb-4">{t('nav.contact')}</p>
            <ul className="space-y-3">
              <li>
                <a href="tel:+41227001234" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  +41 22 700 12 34
                </a>
              </li>
              <li>
                <a href="mailto:contact@byron-properties.ch" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  contact@byron-properties.ch
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-[#666] hover:text-[#1A1A1A] transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Languages */}
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[#999] mb-4">Language</p>
            <div className="flex gap-4 text-sm">
              <button 
                onClick={() => setLanguage('en')}
                className={language === 'en' ? 'text-[#1A1A1A]' : 'text-[#666] hover:text-[#1A1A1A] transition-colors'}
              >
                EN
              </button>
              <button 
                onClick={() => setLanguage('fr')}
                className={language === 'fr' ? 'text-[#1A1A1A]' : 'text-[#666] hover:text-[#1A1A1A] transition-colors'}
              >
                FR
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#E5E5E0] mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#999]">
            © {currentYear} Byrōn Properties. {t('footer.allRightsReserved')}
          </p>
          <div className="flex gap-6 text-xs text-[#999]">
            <Link to="/privacy" className="hover:text-[#666] transition-colors">
              {language === 'fr' ? 'Confidentialité' : 'Privacy'}
            </Link>
            <Link to="/cookies" className="hover:text-[#666] transition-colors">
              {language === 'fr' ? 'Cookies' : 'Cookies'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
